<template>
	<div class="player_row">
		<div class="player_col">
			{{ player.shirt_number }}
		</div>
		<div class="player_col">
			<div class="player_command">
				<img :src="$hostname + '/img/country/' +  player.country_code" alt="">
				<span>{{ player.name }}</span>
			</div>
		</div>
		<div class="player_col">
			{{ player.age }}
		</div>
		<div class="player_col">
			{{ player.height }}
		</div>
		<div class="player_col">
			{{ player.weight }}
		</div>
		<div class="player_col">-</div>
		<div class="player_col">-</div>
	</div>
</template>

<script>
	export default {
		props: ['player'],
		
		created() {
			
		}
	}
</script>

<style scoped>

</style>